<router-outlet />
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="ball-spin"
    [fullScreen]="true"></ngx-spinner>